export default "__VITE_ASSET__DyCGAALy__"